import * as React from 'react';
import { Dropdown, DropDownProps } from 'antd';
import styles from './index.module.less';

const HeaderDropdown = ({ overlayClassName: cls, ...props } : DropDownProps) => {
  return (
    <Dropdown
      className={styles.dropdown}
      overlayClassName="global-right-content-menu"
      placement="bottomRight"
      arrow
      {...props}
    />
  );
};

export default HeaderDropdown;
